import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {TicketService} from "../../../service/api/ticket.service";
import {TmTicketDto} from "../../../model/dto/entity/tm-ticket.dto";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationProviderGeneric
} from "../../../../../core/shared/navigation/impl/mvs-object-navigation-provider-generic";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";

// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'tm-active-ticket',
    templateUrl: './tm-active-ticket.component.html',
    standalone: false
})
export class TmActiveTicketComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    @Input() ticketId: number;
    ticketDto: TmTicketDto;

    constructor(protected ticketService: TicketService, protected navigationService: MvsObjectNavigationService) {
    }

    ngOnInit(): void {

        // to open ticket drawer
        this.navigationService.setNavigationProvider(new MvsObjectNavigationProviderGeneric());

        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshActiveTicket();
        this.initialized = true;
    }

    openTicketDrawer(ticketId: number) {
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry("tm.Ticket", ticketId, null, "Ticket", null, null, MvsObjectNavigationActionEnum.any);
        this.navigationService.navigateTo(mvsObjectNavigationEntry, 'right');
    }


    refreshActiveTicket() {
        this.ticketService.get(this.ticketId).subscribe((ticket: TmTicketDto) => {
            this.ticketDto = ticket;
        })
    }


    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["ticketId"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

}
